let Photos2000=[
  {
    "NameEN": "2000",
    "Image": "un29",
    "CaptionEN": "US President George W Bush defends the second Gulf War, 2004 [Getty Images]",
    "CaptionAR": "الرئيس الأميركي جورج بوش الابن يدافع عن حرب الخليج الثانية عام 2004 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un33",
    "CaptionEN": "Former Libyan leader Colonel Muammar Gaddafi giving his first and only UNGA speech after 40 years in power, 2009 [Getty Images]",
    "CaptionAR": "الزعيم الليبي الراحل معمر القذافي يلقي خطابا أمام الجمعية العامة عام 2009 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un32",
    "CaptionEN": "Angela Merkel, a former research scientist and the first female Chancellor of Germany, 2007 [Reuters]",
    "CaptionAR": "أنجيلا ميركل باحثة وأكاديمية وأول امرأة  تصبح مستشارة ألمانيا عام 2007 (رويترز)"
  },
  {
    "NameEN": null,
    "Image": "un31",
    "CaptionEN": "Venezuelan President Hugo Chavez referencing famed author Noam Chomsky's book helped boost the author's sales, 2006 [Getty Images]",
    "CaptionAR": "الرئيس الفنزويلي هوغو شافيز يعرض غلاف كتاب لمؤلفه نعوم تشومسكي مما زاد في حجم مبيعاته عام 2006 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un30",
    "CaptionEN": "Yad Vashem's Hall of Names in Jerusalem, Holocaust Memorial Day, 2005 [Getty Images]",
    "CaptionAR": "قاعة الأسماء في متحف \"الكارثة والبطولة \" بالقدس المحتلة في ذكرى الهولوكوست عام 2005 (غيتي)"
  }
]
export default Photos2000